module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BookOblique.823522a3.woff2";